import React from 'react';
import { Text, Platform } from 'react-native';
import chatStyles from '../styles/chatStyles';

export const BoldText = (props) => (
  <Text
    style={
      Platform.OS === 'ios'
        ? chatStyles.chatBoldTextIOS
        : chatStyles.chatBoldText
    }
  >
    {props.children}
  </Text>
);
